/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, codes: NonNullable<unknown> }} Error_Kiotviet_Items_UnlinkedInputs */

const vi_error_kiotviet_items_unlinked = /** @type {(inputs: Error_Kiotviet_Items_UnlinkedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Còn ${i?.count} dòng chưa nối sản phẩm: ${i?.codes}`)
};

/**

* @param {Error_Kiotviet_Items_UnlinkedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_kiotviet_items_unlinked = /** @type {((inputs: Error_Kiotviet_Items_UnlinkedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Kiotviet_Items_UnlinkedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_kiotviet_items_unlinked(inputs)
});